import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { OFFICE_INTRO_SAMPLE } from "../consts";
import { OfficeSceneProps } from "../types";

/** Korak "Telefoni": brojevi poslovnice s opisom i poziv na primarni broj. */
const OfficePhoneScene: React.FC<OfficeSceneProps> = ({ name }) => {
  const primaryPhone = OFFICE_INTRO_SAMPLE.phones.find((phone) => phone.primary);

  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Telefoni</div>
          <div className="text-sm font-bold text-slate-800 truncate">{name}</div>
          <div className="mt-3 space-y-2">
            {OFFICE_INTRO_SAMPLE.phones.map((phone) => (
              <div key={phone.number} className="rounded-md bg-slate-50 px-3 py-2 text-[0.7rem]">
                <div className="flex items-center justify-between gap-2">
                  <span className="font-semibold text-slate-700 truncate">{phone.number}</span>
                  {phone.primary && (
                    <span className="px-1.5 py-0.5 rounded-full text-[0.55rem] font-semibold bg-blue-100 text-blue-700">
                      Primarni
                    </span>
                  )}
                </div>
                <div className="text-[0.6rem] text-slate-400 truncate">{phone.description}</div>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Poziv</div>
          <div className="mt-2 text-xs font-bold text-slate-800 truncate">{name}</div>
          <div className="text-[0.65rem] text-slate-400">{primaryPhone?.number}</div>
          <div className="mt-3 flex gap-2">
            <span className="flex-1 rounded-sm bg-emerald-500 py-1 text-center text-[0.6rem] font-semibold text-white">Nazovi</span>
            <span className="flex-1 rounded-sm bg-slate-100 py-1 text-center text-[0.6rem] font-semibold text-slate-600">SMS</span>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Zna se tko se javlja"
          subtitle="Opis uz svaki broj"
          iconClassName="bg-amber-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#B45309" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6A19.79 19.79 0 012.12 4.18 2 2 0 014.11 2h3a2 2 0 012 1.72c.13.96.36 1.9.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0122 16.92z" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(OfficePhoneScene);
